import { render } from "./AuthSignUp.vue?vue&type=template&id=5021e9a4"
import script from "./AuthSignUp.vue?vue&type=script&lang=js"
export * from "./AuthSignUp.vue?vue&type=script&lang=js"
script.render = render

export default script